import { apiClient } from '../api-client.config';

export interface TeamStat {
  teamId: string;
  fixtureId: string;
  statType: string;
  value: number;
}

export interface PlayerStat {
  playerId: string;
  playerName: string;
  teamId: string;
  fixtureId: string;
  statType: string;
  value: number;
}

export interface AttemptData {
  teamStats: TeamStat[];
  playerStats: PlayerStat[];
}

export async function getMatchStatsAttemptData(
  fixtureId: string,
  attemptId: string
): Promise<AttemptData> {
  return apiClient.get(
    `/api/admin/live-scoring/fixture/${fixtureId}/match-stats/attempts/${attemptId}/data` as never
  ) as Promise<AttemptData>;
}
